<template>
  <div class="toast-host" role="status" aria-live="polite">
    <transition-group name="toast">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="toast"
        :class="t.type"
        @click="remover(t.id)"
      >
        <i class="toast-icon" :class="icone(t.type)"></i>
        <span class="toast-text">{{ t.message }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toasts, remover } from '@/plugins/toast';

export default {
  name: 'ToastHost',

  setup() {
    const icone = (type) => ({
      success: 'fas fa-check-circle',
      error: 'fas fa-exclamation-circle',
      warning: 'fas fa-exclamation-triangle',
      info: 'fas fa-info-circle'
    }[type] || 'fas fa-info-circle');

    return { toasts, remover, icone };
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/colors.scss';

.toast-host {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  pointer-events: none;
}

.toast {
  pointer-events: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  min-width: 260px;
  max-width: min(90vw, 420px);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background: rgba(#1a1a1a, 0.95);
  border-left: 4px solid $primary-blue;
  color: #eee;
  font-size: 0.9rem;
  line-height: 1.35;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.5);

  &.success { border-left-color: #3fd07a; .toast-icon { color: #3fd07a; } }
  &.error { border-left-color: $primary-red; .toast-icon { color: $primary-red; } }
  &.warning { border-left-color: #ffb547; .toast-icon { color: #ffb547; } }
  &.info { border-left-color: $primary-blue; .toast-icon { color: $primary-blue; } }
}

.toast-text {
  flex: 1;
  word-break: break-word;
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(24px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(24px);
}

@media (max-width: 600px) {
  .toast-host {
    top: auto;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
  }

  .toast {
    min-width: 0;
    max-width: none;
  }
}
</style>
